module.exports = __webpack_public_path__ + "img/西红花.5b92ab84.jpg";